module.exports = __webpack_public_path__ + "static/media/code-lab.28686b28.svg";